/**
 * Lo stato dell'Accademia per gli operatori.
 *
 * AC0 (6/10/2026): il modulo usciva in ANTEPRIMA, aperto a una lista di email
 * scritta qui (i piloti). M6 (22/10/2026): la lista non c'e' piu'. L'Accademia
 * e' del Pro (decisione founder: i corsi video solo con l'abbonamento) oppure
 * di chi ha la CONCESSIONE dal system admin (/admin/concessioni). La verita'
 * sta sul server: `/auth/me` porta `accademia_attiva` (modulo acceso), qui si
 * legge soltanto.
 */
export function accademiaAperta(user) {
  return !!user?.accademia_attiva;
}

// La voce «Corsi» nel menu del marketplace pubblico: entra quando ci saranno
// corsi pubblicati da mostrare (RF). Non c'entra con chi puo' pubblicare.
export const ACCADEMIA_UI_PRONTA = false;
